module.exports = __webpack_public_path__ + "static/img/tdsmall2.1cdca7e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/page-one/img/tdsmall2.jpg
// module id = pFwU
// module chunks = 0